import Dialog from '@mui/material/Dialog';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material';
import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';

export const LegalDialog = () => {
  const router = useRouter();
  const { legal } = router.query;
  const [params, setParams] = useState<Record<string, unknown> | null>(null);
  useEffect(() => {
    if (!params) {
      setParams(router?.query);
    }
  }, [params, router?.query]);
  const removeLegalParam = () => {
    if (!params) {
      return;
    }
    router.replace({
      pathname: router.pathname,
      query: {
        ...params,
        legal: undefined,
      },
    });
  };
  const legalUrl = `assets/legal/${
    legal === 'privacy'
      ? 'BluMint Inc Privacy Policy'
      : 'BluMint Inc Terms of Use'
  }.pdf`;
  const theme = useTheme();
  return (
    <Dialog
      open={!!legal}
      onClose={removeLegalParam}
      color="secondary"
      maxWidth="xl"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        backdropFilter: theme.glass[16],
        '& .MuiPaper-root': {
          borderRadius: '10px',
        },
      }}
    >
      <Box
        sx={{
          height: 1000,
          width: 890,
          boxShadow:
            '0.5px 2px 25px 3px rgba(0, 51, 233, 0.15), 0px 1px 15px 1px rgba(0, 51, 233, 0.3)',
          border: 'double 2px transparent',
          borderRadius: '10px',
          backgroundImage: `linear-gradient(${theme.palette.background.elevation[16]}, 
            ${theme.palette.background.elevation[16]}), linear-gradient(180deg, #4DC8FF 0%, #0064E9 100%)`,
          backgroundOrigin: 'border-box',
          backgroundClip: 'content-box, border-box',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            p: 4,
            borderRadius: 4,
            height: '100%',
          }}
        >
          <embed src={legalUrl} type="application/pdf" height="100%" />
        </Box>
      </Box>
    </Dialog>
  );
};
